module.exports = "<div id=\"rebar-detail\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sketch/rebar-detail/rebar-detail.component.html
// module id = 792
// module chunks = 0